import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const useShowLabDocumentsTab = (): boolean => {
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.SHOW_LAB_DOCUMENTS_TAB,
  );
  return growthBookEnabled;
};
